var Gradient = /** @class */ (function () {
    function Gradient() {
        this.stops = [];
    }
    return Gradient;
}());
export { Gradient };
//# sourceMappingURL=gradient.js.map